(function () {
  const DEFAULT_ENDPOINT = 'https://n8n.tnmseo.com/webhook/lumira-trade';

  function jsonScript(id, fallback) {
    const node = document.getElementById(id);
    if (!node) return fallback;
    try {
      return JSON.parse(node.textContent || '');
    } catch (_) {
      return fallback;
    }
  }

  function status(node, text, tone) {
    if (!node) return;
    node.textContent = text;
    node.dataset.tone = tone || 'neutral';
  }

  function formDataToJson(form) {
    const data = {};
    new FormData(form).forEach((value, key) => {
      if (value && typeof value === 'object' && 'name' in value) {
        data[key] = value.name || '';
      } else {
        data[key] = value;
      }
    });
    return data;
  }

  function initApplication() {
    const form = document.querySelector('[data-trade-application-form]');
    if (!form) return;
    const endpoint = form.getAttribute('data-endpoint') || DEFAULT_ENDPOINT + '/application';
    const message = document.querySelector('[data-trade-application-status]');
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const payload = {
        prefix: '[TRADE-APPLICATION]',
        submitted_at: new Date().toISOString(),
        source: window.location.href,
        application: formDataToJson(form)
      };
      status(message, 'Submitting application for review...', 'busy');
      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!response.ok) throw new Error('Application endpoint unavailable');
        form.reset();
        status(message, 'Application received. Lumira will review and follow up after approval.', 'success');
      } catch (error) {
        status(message, 'Application saved locally. Please email info@lumirafurn.com if you do not receive confirmation.', 'error');
        try {
          localStorage.setItem('lumiraTradeApplicationDraft', JSON.stringify(payload));
        } catch (_) {}
      }
    });
  }

  function memberLimit(tier) {
    if (tier === 'trade_maison' || tier === 'maison') return 999;
    if (tier === 'trade_atelier' || tier === 'atelier') return 20;
    return 5;
  }

  function tierName(tags) {
    if (tags.includes('trade_maison')) return 'Maison';
    if (tags.includes('trade_atelier')) return 'Atelier';
    return 'Studio';
  }

  function normalizeRender(item) {
    return {
      product_id: String(item.product_id || item.id || ''),
      title: item.title || 'Lumira product',
      brand: item.brand || item.public_brand || 'Lumira',
      category: item.category || item.product_type || item.product_kind || 'Furniture',
      image: item.image || item.image_url || '',
      product_url: item.product_url || item.url || '#',
      render_url: item.render_url || ''
    };
  }

  function initPortal() {
    const root = document.querySelector('[data-trade-portal]');
    if (!root) return;
    const customer = jsonScript('LumiraTradeCustomer', {});
    const tags = customer.tags || [];
    const tier = tierName(tags);
    const used = Number(customer.downloads_this_month || localStorage.getItem('lumiraTradeDownloadsThisMonth') || 0);
    const limit = memberLimit(tier.toLowerCase());
    const tierLabel = root.querySelector('[data-trade-tier]');
    const usedLabel = root.querySelector('[data-trade-used]');
    const fill = root.querySelector('[data-trade-progress]');
    if (tierLabel) tierLabel.textContent = tier;
    if (usedLabel) usedLabel.textContent = `${Math.min(used, limit)} of ${limit === 999 ? '21+' : limit} renders used this month`;
    if (fill) fill.style.setProperty('--progress', `${Math.min(100, Math.round((used / limit) * 100))}%`);

    const grid = root.querySelector('[data-render-grid]');
    const search = root.querySelector('[data-render-search]');
    const brand = root.querySelector('[data-render-brand]');
    const category = root.querySelector('[data-render-category]');
    const message = root.querySelector('[data-render-status]');
    const endpoint = root.getAttribute('data-endpoint') || DEFAULT_ENDPOINT + '/render';
    let renders = [];

    function optionize(select, values) {
      if (!select) return;
      values.filter(Boolean).sort().forEach((value) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });
    }

    optionize(brand, [...new Set(renders.map((item) => item.brand))]);
    optionize(category, [...new Set(renders.map((item) => item.category))]);

    async function download(item) {
      const current = Number(localStorage.getItem('lumiraTradeDownloadsThisMonth') || used || 0);
      if (current >= limit) {
        status(message, 'Render limit reached for this tier. Upgrade to continue downloading this month.', 'error');
        return;
      }
      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ product_id: item.product_id, designer_id: customer.id || customer.email || 'theme-user' })
        });
        const data = response.ok ? await response.json() : {};
        const url = data.url || item.render_url;
        if (!url) throw new Error('Render unavailable');
        localStorage.setItem('lumiraTradeDownloadsThisMonth', String(current + 1));
        window.location.href = url;
      } catch (_) {
        if (item.render_url) {
          localStorage.setItem('lumiraTradeDownloadsThisMonth', String(current + 1));
          window.location.href = item.render_url;
        } else {
          status(message, 'This render is queued and will appear after generation completes.', 'error');
        }
      }
    }

    function setRenders(items) {
      renders = (items || []).map(normalizeRender);
      if (brand) brand.querySelectorAll('option:not(:first-child)').forEach((node) => node.remove());
      if (category) category.querySelectorAll('option:not(:first-child)').forEach((node) => node.remove());
      optionize(brand, [...new Set(renders.map((item) => item.brand))]);
      optionize(category, [...new Set(renders.map((item) => item.category))]);
      render();
    }

    async function loadRenders() {
      const value = jsonScript('LumiraTradeRenders', []);
      if (typeof value === 'string') {
        try {
          const response = await fetch(value);
          const payload = await response.json();
          setRenders(payload.renders || payload.products || payload);
        } catch (_) {
          setRenders([]);
        }
      } else {
        setRenders(value);
      }
    }

    function render() {
      if (!grid) return;
      const q = (search && search.value || '').trim().toLowerCase();
      const b = brand && brand.value || '';
      const c = category && category.value || '';
      const rows = renders.filter((item) => {
        if (q && !`${item.title} ${item.brand} ${item.category}`.toLowerCase().includes(q)) return false;
        if (b && item.brand !== b) return false;
        if (c && item.category !== c) return false;
        return true;
      });
      grid.innerHTML = '';
      rows.forEach((item) => {
        const card = document.createElement('article');
        card.className = 'lumira-render-card';
        card.innerHTML = `
          <img src="${item.image}" alt="">
          <h3>${item.title}</h3>
          <p>${item.brand} · ${item.category}</p>
          <a class="lumira-trade__button lumira-trade__button--secondary" href="${item.product_url}">View Product</a>
          <button class="lumira-trade__button" type="button">${item.render_url ? 'Download Video' : 'Render Queued'}</button>
        `;
        card.querySelector('button').addEventListener('click', () => download(item));
        grid.appendChild(card);
      });
      status(message, rows.length ? `${rows.length} render assets available.` : 'No renders match this filter.', 'neutral');
    }

    [search, brand, category].forEach((node) => node && node.addEventListener('input', render));
    loadRenders();
  }

  initApplication();
  initPortal();
})();
